module.exports = __webpack_public_path__ + "img/TH.f4d21baa.svg";